import { render } from "./AppAktivitetet.vue?vue&type=template&id=e03d8d12"
import script from "./AppAktivitetet.vue?vue&type=script&lang=js"
export * from "./AppAktivitetet.vue?vue&type=script&lang=js"

import "./AppAktivitetet.vue?vue&type=style&index=0&id=e03d8d12&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__